import React from "react";
import "./component-styles.scss";

function PageHeader(props) {
  return (
    <div className="main-page-header" style={{ flex: 1 }}>
      <h1 className="m-0 p-0">{props.heading}</h1>
      {props.subheading ? <p>{props.subheading}</p> : ""}
    </div>
  );
}

export default PageHeader;
